
export default {
  name: "the-email",
  props: {
    title: {
      required: true,
      default: ''
    },
    description: {
      required: true,
      default: ''
    },
    layout: {
      required: false,
      default: 'chain',
      type: String
    },
    error: {
      required: false,
      default: '',
      type: String
    },
    addNewEmailProcess: {
      required: false,
      default: false,
      type: Boolean
    },
    currentEmail: {
      required: false,
      default: null,
      type: String
    }
  },
  data() {
    return {
      email: '',
      rules: {
        required: value => !!value || 'Dette feltet er obligatorisk.',
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9_]+\.)+[a-zA-Z]{2,}))$/
          const unspportedDomains = ['yourwish.no']
          const illegalDomain = unspportedDomains.includes(value.split('@')[1])
          return pattern.test(value) && !illegalDomain || (illegalDomain ? 'Dette domenet kan ikke brukes.' : 'Ugyldig e-postaddresse.')
        },
      },
      validated: false,
    }
  },
  methods: {
    submit(event) {
      event.preventDefault();
      this.onInput(event?.srcElement?._value)
      this.$emit("verify");
    },
    onInput(value) {
      this.$emit("setValue", value);
    },
    validate() {
      return this.validated
    }
  },
  mounted() {
    this.$nextTick(() => {
      setTimeout(() => {
        this.$refs.emailInput.$refs.input.focus()
      })
    })
  }
}
